"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTypeaheadResponseV8 = exports.buildTypeaheadURLV8 = exports.buildUnifiedSearchURLV8 = exports.fetchTypeaheadResponse = exports.fetchConfig = exports.addFiltersToTypeaheadURL = exports.buildUnifiedSearchURL = exports.buildLocationQuery = exports.buildTypeaheadURL = exports.buildConfigURL = exports.buildTypeaheadRequestOptions = void 0;
const constants_1 = require("./constants");
/**
 * Builds any request options that need to be passed along in the
 * fetch call
 * @param config Config
 * @returns Dict<any> (object)
 */
const buildTypeaheadRequestOptions = (config, productName) => {
    return {
        headers: {
            'X-Consumer-Groups': config.customer_code,
            'X-Consumer-Username': productName
        }
    };
};
exports.buildTypeaheadRequestOptions = buildTypeaheadRequestOptions;
/**
 * Builds the base URL for the route that return search widget configs
 * @param id string
 * @param pmcUrl string (optional)
 * @returns string
 */
const buildConfigURL = (id, pmcUrl) => {
    const baseUrl = pmcUrl ? pmcUrl : '';
    return `${baseUrl}${constants_1.CONFIG_URL}/${id}`;
};
exports.buildConfigURL = buildConfigURL;
/**
 * Builds the base URL for the route that returns typeahead suggestions.
 * Terms would come from the search input value/text and the rest of the
 * params come from the search widget config
 * @param config Config
 * @param terms string
 * @param pmcUrl string (optional)
 * @returns string
 */
const buildTypeaheadURL = (config, terms, pmcUrl) => {
    const params = new URLSearchParams();
    const baseUrl = pmcUrl ? pmcUrl : '';
    const categories = config.params.typeahead_categories.map((category) => category.category);
    params.append('terms', terms);
    params.append('categories', categories.join(','));
    params.append('context', config.index);
    if (config.params.filters) {
        (0, exports.addFiltersToTypeaheadURL)('filter', params, config.params.filters);
    }
    if (config.params.or_filters) {
        (0, exports.addFiltersToTypeaheadURL)('_filter', params, config.params.or_filters);
    }
    if (config.params.not_filters) {
        (0, exports.addFiltersToTypeaheadURL)('-filter', params, config.params.not_filters);
    }
    // route in PMC is passthrough to search, so must include the customer code
    return `${baseUrl}${constants_1.TYPEAHEAD_URL}/${config.customer_code}/typeahead?${params.toString()}`;
};
exports.buildTypeaheadURL = buildTypeaheadURL;
/**
 * Builds a query string for location input
 * @param location string
 * @param radius number
 * @returns string
 */
const buildLocationQuery = (location, radius = 0) => {
    const params = new URLSearchParams();
    params.append('location', location);
    params.append('distance', radius.toString());
    return params.toString();
};
exports.buildLocationQuery = buildLocationQuery;
/**
 * Builds the base URL for the route that returns search results.
 * Terms would come from the search input value/text and the rest of the
 * params come from the search widget config. If we have no terms, then
 * this is an empty search and we just include the stuff from the config
 * @param config Config
 * @param terms string (optional)
 * @param pmcUrl string (optional)
 * @returns string
 */
const buildUnifiedSearchURL = (config, terms, pmcUrl) => {
    const params = new URLSearchParams();
    const baseUrl = pmcUrl ? pmcUrl : '';
    const categories = config.params.typeahead_categories.map((category) => category.category);
    if (terms) {
        params.append('unified', terms);
    }
    params.append('categories', categories.join(','));
    if (config.params.sort_order) {
        params.append('sort', config.params.sort_order.join(','));
    }
    if (config.params.filters) {
        (0, exports.addFiltersToTypeaheadURL)('filter', params, config.params.filters);
    }
    if (config.params.or_filters) {
        (0, exports.addFiltersToTypeaheadURL)('_filter', params, config.params.or_filters);
    }
    if (config.params.not_filters) {
        (0, exports.addFiltersToTypeaheadURL)('-filter', params, config.params.not_filters);
    }
    return `${baseUrl}${constants_1.SEARCH_URL}?${params.toString()}`;
};
exports.buildUnifiedSearchURL = buildUnifiedSearchURL;
/* Adds the filters params the typeahead URL. In search v9, there are 3 different
 * filters that can be added:
 *  - filter: standard filters
 *  - _filter: OR filters
 *  - -filter: NOT filter
 * @param qsParam string
 * @param params URLSearchParams
 * @param filters Filter[]
 */
const addFiltersToTypeaheadURL = (qsParam, params, filters) => {
    filters.forEach((filter) => {
        params.append(qsParam, filter);
    });
};
exports.addFiltersToTypeaheadURL = addFiltersToTypeaheadURL;
/**
 * Fetches the config used to initialize the search widget
 * @param id string
 * @param pmcUrl string (optional)
 * @returns Promise<Config>
 */
const fetchConfig = (id, pmcUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch((0, exports.buildConfigURL)(id, pmcUrl));
    return getResponseJSON(res);
});
exports.fetchConfig = fetchConfig;
/**
 * Fetches the typeahead response from search
 * @param config Config
 * @param terms string
 * @param pmcUrl string (optional)
 * @returns TypeaheadResponse
 */
const fetchTypeaheadResponse = (config, terms, productName, pmcUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch((0, exports.buildTypeaheadURL)(config, terms, pmcUrl), (0, exports.buildTypeaheadRequestOptions)(config, productName));
    return getResponseJSON(res);
});
exports.fetchTypeaheadResponse = fetchTypeaheadResponse;
/**
 * Encapsulates returning the JSON promise from a response for reuse
 * across fetch functions
 * @param response Response
 * @returns Promise<any>
 */
const getResponseJSON = (response) => __awaiter(void 0, void 0, void 0, function* () {
    if (!response.ok) {
        throw new Error(response.statusText);
    }
    return response.json();
});
/*****************************************************************
 * EVERYTHING BELOW THIS LINE SHOULD GO AWAY WHEN WE MIGRATE TO V9
 *****************************************************************/
/**
 * Builds the base URL for the route that returns search results.
 * Terms would come from the search input value/text and the rest of the
 * params come from the search widget config. If we have no terms, then
 * this is an empty search and we just include the stuff from the config
 * @param config Config
 * @param terms string (optional)
 * @param pmcUrl string (optional)
 * @returns string
 */
const buildUnifiedSearchURLV8 = (config, terms, pmcUrl) => {
    const params = new URLSearchParams();
    const baseUrl = pmcUrl ? pmcUrl : '';
    if (terms) {
        params.append('unified', terms);
    }
    if (config.params.sort_order) {
        params.append('sort', config.params.sort_order.join(','));
    }
    if (config.params.filters) {
        (0, exports.addFiltersToTypeaheadURL)('filter', params, config.params.filters);
    }
    if (config.params.or_filters) {
        (0, exports.addFiltersToTypeaheadURL)('_filter', params, config.params.or_filters);
    }
    if (config.params.not_filters) {
        (0, exports.addFiltersToTypeaheadURL)('-filter', params, config.params.not_filters);
    }
    return `${baseUrl}${constants_1.SEARCH_URL}?${params.toString()}`;
};
exports.buildUnifiedSearchURLV8 = buildUnifiedSearchURLV8;
/**
 * https://support.kyruus.com/hc/en-us/articles/360000680183-Integrating-Typeahead-with-Search
 *
 * Build and returns the `typeahead_categories` param
 *  e.g: -ALL,+clinical_experience,+specialty_synonym,+practice_group,+name
 */
const buildTypeaheadCategoriesParams = (config) => {
    const categories = config.params.typeahead_categories.map(({ category }) => `+${category}`);
    return ['-ALL', ...categories].join(',');
};
/**
 * Builds the base URL for the route that returns typeahead suggestions.
 * Terms would come from the search input value/text and the rest of the
 * params come from the search widget config
 *
 *
 * @param config Config
 * @param terms string
 * @returns string
 */
const buildTypeaheadURLV8 = (config, terms, pmcUrl) => {
    const baseUrl = pmcUrl || '';
    const params = new URLSearchParams();
    params.append('typeahead_categories', buildTypeaheadCategoriesParams(config));
    if (config.params.filters) {
        (0, exports.addFiltersToTypeaheadURL)('filter', params, config.params.filters);
    }
    if (config.params.or_filters) {
        (0, exports.addFiltersToTypeaheadURL)('_filter', params, config.params.or_filters);
    }
    if (config.params.not_filters) {
        (0, exports.addFiltersToTypeaheadURL)('-filter', params, config.params.not_filters);
    }
    return `${baseUrl}${constants_1.TYPEAHEAD_V8_URL}/${encodeURIComponent(terms)}?${params.toString()}`;
};
exports.buildTypeaheadURLV8 = buildTypeaheadURLV8;
/**
 * Fetches the typeahead response from search
 * @param config Config
 * @param terms string
 * @returns TypeaheadResponseV8
 */
const fetchTypeaheadResponseV8 = (config, terms, productName, pmcUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch((0, exports.buildTypeaheadURLV8)(config, terms, pmcUrl), (0, exports.buildTypeaheadRequestOptions)(config, productName));
    const json = yield getResponseJSON(res);
    for (const key in json) {
        /**
         * `provider_name` is an alias for `name`.
         * `provider_name` is what is meant to be used on the next api versions
         * https://support.kyruus.com/hc/en-us/articles/360000680183-Integrating-Typeahead-with-Search
         *
         * However, on search v8, if you ask for:
         * typeahead_categories=provider_name
         * The response that comes back will be indexed with the alias `name`
         *
         * On v9 this check should go away (KENG-33276)
         */
        if (key === 'name' &&
            config.validTypeaheadCategories.has('provider_name')) {
            json.provider_name = json.name;
        }
        const currCategory = key;
        if (!config.validTypeaheadCategories.has(currCategory)) {
            delete json[currCategory];
        }
    }
    return json;
});
exports.fetchTypeaheadResponseV8 = fetchTypeaheadResponseV8;
//# sourceMappingURL=api.js.map